import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const AUTH_PREFIXES = ['/login', '/register', '/reset-password', '/verify-email', '/auth/', '/dashboard', '/admin', '/rfp'];

const LanguageSwitcher = ({ variant = "ghost", size = "sm" }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const path = location.pathname;
    const isAuthRoute = AUTH_PREFIXES.some(p => path.startsWith(p));

    if (isAuthRoute) {
      i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr');
      return;
    }
    if (i18n.language === 'fr') {
      navigate(path === '/' ? '/en' : `/en${path}`);
    } else {
      navigate(path === '/en' ? '/' : path.replace(/^\/en/, '') || '/');
    }
  };
  
  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleLanguage}
      className="flex items-center gap-2"
      data-testid="language-switcher"
    >
      <span className="text-lg">{i18n.language === 'en' ? '🇫🇷' : '🇬🇧'}</span>
      <span className="font-medium">{i18n.language === 'en' ? 'FR' : 'EN'}</span>
    </Button>
  );
};

export default LanguageSwitcher;
